import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { colorTokens } from '../theme/tokens';
/**
 * AppSelect — native <select> matching the V3-UX `Sel` component exactly.
 *
 * Design spec (from PondLogs-V3-UX SettingsPage):
 *   padding       : 8px 12px     (px-3 py-2)
 *   border-radius : 12px         (rounded-xl)
 *   border        : 1px solid    (border)
 *   font-size     : 12px         (text-xs)
 *   outline       : none         (outline-none)
 *   border-color  : borderLight  — static on all states; error → colorTokens.error
 *   color         : #333         (disabled → gray400)
 *   background    : white        (disabled → gray50)
 *   width         : 100% when fullWidth, minWidth 160 otherwise
 */
export const AppSelect = ({ options, value, onChange, label, placeholder, helperText, error = false, disabled = false, fullWidth = true, required = false, sx, }) => {
    const selectStyle = {
        padding: '8px 12px',
        borderRadius: 12,
        border: `1px solid ${error ? colorTokens.error : colorTokens.borderLight}`,
        fontSize: 12,
        lineHeight: '16px',
        fontFamily: 'inherit',
        outline: 'none',
        color: disabled ? colorTokens.gray400 : '#333',
        background: disabled ? colorTokens.gray50 : colorTokens.white,
        width: fullWidth ? '100%' : undefined,
        minWidth: fullWidth ? undefined : 160,
        cursor: disabled ? 'not-allowed' : 'pointer',
        appearance: 'auto',
        boxSizing: 'border-box',
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 4, ...sx }, children: [label && (_jsxs("label", { style: {
                    fontSize: 11,
                    fontWeight: 600,
                    color: error ? colorTokens.error : colorTokens.primary,
                }, children: [label, required && ' *'] })), _jsxs("select", { value: String(value), onChange: (e) => onChange(e.target.value), disabled: disabled, style: selectStyle, children: [placeholder && (_jsx("option", { value: "", disabled: true, children: placeholder })), options.map((opt) => (_jsx("option", { value: String(opt.value), children: opt.label }, opt.value)))] }), helperText && (_jsx("span", { style: {
                    fontSize: 10,
                    color: error ? colorTokens.error : colorTokens.darkGrey,
                    marginTop: 2,
                }, children: helperText }))] }));
};
